import type { BracketSlot, PickemTeam } from '../types'

// Заполнение пустого слота bracket-матча (когда `team === null`) текстом-плейсхолдером.
// Это решение из docs/pickem/docs/technical/03-api-basic.md и
// docs/pickem/docs/functional/15-mockups.md → «Победитель матча #N» / «Сид #N».
//
// Принципы:
// - fill_rule='seed' → «Сид #1» (или «Команда не посеяна», если seed_index пуст).
// - fill_rule='winner_of' → «Победитель матча #N».
// - fill_rule='loser_of' → «Проигравший матча #N».
//
// Точные id матчей подставляются в #N. Локализация — пока ru-only (см. plan.md).

export const bracketSlotLabel = (
  slot: BracketSlot,
  displayTeam: PickemTeam | null = slot.team
): string => {
  if (displayTeam) return displayTeam.name

  switch (slot.fill_rule) {
    case 'seed':
      return slot.seed_index ? `Сид #${slot.seed_index}` : 'Команда не посеяна'
    case 'winner_of':
      return slot.source_match_id
        ? `Победитель матча #${slot.source_match_id}`
        : 'Победитель предыдущего матча'
    case 'loser_of':
      return slot.source_match_id
        ? `Проигравший матча #${slot.source_match_id}`
        : 'Проигравший предыдущего матча'
    default:
      return ''
  }
}
